import { SET_POST_COUNT } from './set-posts-count';

const postCount = (state: number = 0, { type, payload }: any = {}): number => {
  switch (type) {
    case SET_POST_COUNT:
      return payload;
    default:
      return state;
  }
};

export default postCount;
